import React from "react";
import PageBuilder from "../../components/PageBuilder/PageBuilder";
import { useSanityContent } from "../../hooks/useSanityContent";
import { PAGE_QUERY } from "../../sanity/queries";

const fallbackSections = [
  {
    _type: "heroAlternative",
    title: "Property Management Services",
    description: "Simply put, we provide total oversight and administration of real estate properties, ensuring they are well maintained, tenants are satisfied, and property owners maximise their returns.",
    image: "/real_estate.jpg",
  },
  {
    _type: "alternatingImageText",
    sections: [
      { title: "Commercial Asset Management", description: "Working closely in line with our clients', we provide a dedicated service to help manage the use of space to optimise business premises. We provide strategic advice to clients, to help them unlock value and potential from their commercial property in Liberia. Together with our clients' we develop tailor-made strategies to maximise commercial income as well as focus on value-add opportunities.", image: "/commercial.jpg", imageAlt: "Project audit analysis and reporting" },
      { title: "Our Key Responsibilities", bullets: ["Tenant Management – screening potential tenants, handling lease agreements, addressing tenant issues", "Maintenance and Repairs – coordinating routine inspections, managing maintenance issues and ensuring at all times the property is in good condition", "Financial Management – collection of rent, managing of operating expenses e.g. maintenance and repair costs and providing financial status reports", "Legal Compliance – ensuring the property is compliant with and adheres to all local statutory regulations"], image: "/property.jpg", imageAlt: "Project audit analysis and reporting" },
    ],
  },
  { _type: "contactSection" },
];

export default function PropertyManagement() {
  const { data } = useSanityContent(PAGE_QUERY("property-management"), { sections: fallbackSections });
  return <PageBuilder sections={data.sections} />;
}
